<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="alert alert-warning" role="alert">
        <h4 class="alert-heading">Template not found!</h4>
        <p class="mb-0">The template has been removed or is currently not available.</p>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <button class="btn btn-block btn-danger" @click="remove">Delete Template</button>
        </div>
      </div>
    </window-tab>
  </window>
</template>

<script>
  import { templateIdMixin, windowPropsMixin } from '@/mixins'
  import * as action from '@/store/action-types'

  export default {
    name: 'template-not-found',
    mixins: [templateIdMixin, windowPropsMixin],
    methods: {
      remove () {
        this.$store.dispatch(action.TEMPLATE_DELETE, {
          templateId: this.templateId
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/template-not-found.vue